import * as Yup from 'yup';

const newRegistro = {
    nome: '',
    status: true,
    tipoPessoa: 'FISICA',
    cpf: '',
    cnpj: '',
    estado: null,
    certificado: null,
    senhaCertificadoTemp: '',
    monitoraNfe: false,
    certificadoVencido: false,
};

const validation = Yup.object().shape({
    tipoPessoa: Yup.string()
        .typeError('Este campo é obrigatório')
        .required('Este campo é obrigatório'),
    nome: Yup.string()
        .min(2, 'O campo deve ter no mínimo 2 caracteres')
        .max(60, 'Campo deve ter menos do que 60 caracteres')
        .required('Este campo é obrigatório'),
    estado: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
});

export const certificadoDigitalCadastro = {
    newRegistro,
    validation
};
